import React, {forwardRef} from 'react';

import arrayUtils from '@/utils/arrayUtils';

interface ImageProps {
    src?: string | string[] | null;
    className?: string;
    onTransitionEnd?: React.TransitionEventHandler<HTMLImageElement>;
    alt?: string;
    isSrcDelayed?: boolean;
    width?: number | string;
    height?: number | string;
    'aria-hidden'?: boolean | 'true' | 'false';
    onError?: React.ReactEventHandler<HTMLImageElement>;
}

const Image = forwardRef<HTMLImageElement, ImageProps>((props, ref) => {
    const {
        src,
        className,
        onTransitionEnd,
        alt = '',
        isSrcDelayed,
        width,
        height,
        'aria-hidden': ariaHidden,
        onError,
    } = props;

    if (!src?.length && !isSrcDelayed) return null;

    const imgUrls = arrayUtils.toArray(src);
    const srcSet = imgUrls
        .filter((_image: string, i: number) => {
            return i !== 0;
        })
        .map((image: string, i: number) => {
            return `${image} ${i + 2}x`;
        })
        .join(',');

    return (
        // IA: Image elements should have explicit width and height
        // https://web.dev/optimize-cls/?utm_source=lighthouse&utm_medium=devtools#images-without-dimensions
        <img
            alt={alt}
            aria-hidden={ariaHidden}
            className={className}
            height={height}
            onError={onError}
            onTransitionEnd={onTransitionEnd}
            ref={ref}
            src={imgUrls[0]}
            srcSet={srcSet}
            width={width}
        />
    );
});

export default Image;
